import { formatDateForInput, parseDate } from "../../utils/utils";
import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";

export default <T,>({ name, label, formik, placeholder, onChange, containerClassName, ...props }: IInputProps<T, Date>) => {
    return (
        <InputContainer label={label} name={name} formik={formik} className={containerClassName}>
            <DateInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} {...props} />
        </InputContainer>
    );
}

export const DateInputRow = <T,>({ name, label, formik, placeholder, onChange, containerClassName, ...props }: IInputProps<T, Date>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik} className={containerClassName}>
            <DateInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} {...props} />
        </InputContainerRow>
    );
}

export const DateInputSlim = <T,>({ name, formik, placeholder, onChange, ...props }: ISlimInputProps<T, Date>) => {
    return (
        <input
            type="date"
            name={name as string}
            value={formatDateForInput(formik.values[name] as Date)}
            onChange={e => {
                const value = e.target.value ? parseDate(e.target.value) : null;
                formik.setValues({
                    ...formik.values,
                    [name]: value,
                    ...onChange ? onChange(value) : {},
                });
            }}
            onBlur={formik.handleBlur}
            placeholder={placeholder}
            {...props}
        />
    );
}